module.exports = __webpack_public_path__ + "static/Group 90 Copy-42ee395c4222421aa8009d93391491c8.svg";